import { getApiUrl, PAYMENT_API_URL } from '../../util/api/api'

const finalizePayment = async (basketId: string) => {
  const fetchResponse = await fetch(
    getApiUrl(`${PAYMENT_API_URL}/${basketId}/finalize`), {
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      credentials: 'include',
    }
  )

  if (fetchResponse?.ok) {
    const responseData = await fetchResponse.text()
    return Promise.resolve({ status: fetchResponse.status, data: responseData})
  } else {
    return Promise.reject(fetchResponse ? { status: fetchResponse.status, data: fetchResponse.statusText } : null)
  }
}

export default finalizePayment
